var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"total-item"},[_c('span',{staticClass:"label"},[_vm._v("本次訂單交易實付金額：")]),_c('span',{staticClass:"price"},[_vm._v(_vm._s(_vm._f("dollar")(_vm.instantAmount)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }